<template>
  <div class="container-fluid">
    <h3>Individuelle Konfiguration</h3>
    <div role="toolbar" class="btn-toolbar justify-content-between m-3">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button id="new" @click="addEntry()" class="btn btn-secondary">Neuer Eintrag</button>
    </div>
    <div class="row">
      <div class="col-md-auto" style="min-width:220px;">
        <h4>Kategorien</h4>
        <CTreeView @selectnode="updateList" treeid="firmconfigs"/>
      </div>
      <div class="col">
        <b-table class="mt-3" @row-clicked="openEntry" striped hover :items="rows" :fields="fields">
          <template v-slot:cell(action)="data">
            <font-awesome-icon @click="deleteEntry(data.item.map_id,data.index,$event)" icon="trash"/>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal static="true" size="xl" id="editEntry" @ok="saveEntry">
      <h3>Einstellung</h3>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Name:</label>
            <input id="keyInput" type="text" class="form-control" v-model="editItem.map_id"/>
            <span class="text-muted" style="font-size: 10pt;">{{ editItem.toolTip }}</span>
          </div>
          <div class="form-group">
            <label>Wert:</label>
            <textarea class="form-control" v-model="editItem.value">
            </textarea>
          </div>
          <div class="form-inline">
            <label>Aktualisiert:</label>
            <span disabled class="form-text ml-2">{{ editItem.updated }}</span>
          </div>
        </div>
        <div class="col">
          <b-tabs>
            <b-tab title="Dokumentation">
              <div class="container mt-3" v-html="editItem.htmlDoc">
              </div>
            </b-tab>
            <b-tab title="Bearbeiten">
              <div class="form-group mt-3">
                <label>Hinweis:</label>
                <input type="text" class="form-control" v-model="editItem.toolTip"/>
              </div>
              <div class="form-group">
                <label>Dokumentation</label>
                <div style="width:100%;height:300px;" class="mt-3">
                  <AceEditor ref="docEditor" editorId='docEditor' lang="xml"/>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'
import CTreeView from '@/components/tree/CTreeView.vue'

export default {
  name: 'FirmConfigView',
  components: {
    AceEditor,
    CTreeView
  },
  data() {
    return {
      editItem: {},
      start: 0,
      page: 30,
      catid: 0,
      rows: [],
      fields: [
        {"key":"map_id", "label":"Name"},
        {"key":"value", "label":"Wert"},
        {"key":"toolTip", "label":"Hinweis"},
        {"key":"updated", "label":"letzte Änderung"},
        {"key":"action","label":"Aktion"}
      ]
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    openEntry(row) {
      console.log(row);
      document.getElementById('keyInput').disabled = true;
      this.editItem = row;
      this.$bvModal.show("editEntry");
      this.$refs.docEditor.setContent(this.editItem.htmlDoc);
    },
    deleteEntry(id,index,e) {
      console.log(e);
      e.preventDefault();
      e.stopPropagation();

      console.log('delete: ' + id + '/' + index);
      if (!confirm('Möchten Sie wirklich die Einstellung "' + id + '" löschen?')) {
        return;
      }

      var self = this;
      config.deleteFirmConfig(this,id,function(data) {
        console.log(data);
        self.fetchData();
      });
    },
    fetchData() {
      var self = this;
      config.listFirmConfig(this,this.start,this.page,this.catid,function(data) {
        self.rows = data;
      });
    },
    updateList: function(node) {
      if (node) {
        this.catid = node.id;
        this.fetchData();
      }
    },
    saveEntry() {
      this.editItem.htmlDoc = this.$refs.docEditor.getContent();
      console.log(this.editItem);
      var self = this;
      config.saveFirmConfig(this,this.editItem,function(data) {
        self.editItem = data;
        self.fetchData();
      });
    },
    addEntry() {
      console.log('add new entry');
      document.getElementById('keyInput').disabled = false;
      this.editItem = {"new":true,"categoryId": this.catid };
      this.$bvModal.show('editEntry');
      this.$refs.docEditor.setContent('');
      console.log(this.editItem);
    },
    prevPage: function() {
      if (this.start > 0) {
        this.start -= this.page;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        this.start += this.page;
        this.fetchData();
      }
    },
  }
}
</script>
